// extracted by mini-css-extract-plugin
export var closeButton = "_16-1";
export var container = "_16-0";
export var fullModalImage = "_16-2";